import {getDailyList} from '../api/getDailyList';
import {setGetDailyListAction} from '../action';

const setGetDailyList = (params ) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getDailyList(params);
            
            if (data.status === 'success') {
                dispatch(setGetDailyListAction({
                    list: data.data.list,
                    count: data.data.count,
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetDailyList
}